import moment from 'moment'

const BASE_SEASONS = [
    { start: '01-01', end: '02-29', theme: 'summer', genre: 'pop' },
    { start: '03-01', end: '05-31', theme: 'autumn', genre: 'rap' },
    { start: '06-01', end: '07-31', theme: 'winter', genre: 'rock' },
]

const THEME_TO_GENRE_MAP = {
    'pop': 1,
    'rock': 2,
    'rap': 3,
    'back2school': 4,
    'vday': 5,
    'easter': 6,
    'christmas': 7
}

// Other categories only have the base genres (1-3) and must fall back to BASE_SEASONS.
const SEASONAL_GENRE_CATEGORIES = new Set([46])

// Calculate Easter Sunday using the Gregorian algorithm
function getEasterDate(year) {
    const a = year % 19
    const b = Math.floor(year / 100)
    const c = year % 100
    const d = Math.floor(b / 4)
    const e = b % 4
    const f = Math.floor((b + 8) / 25)
    const g = Math.floor((b - f + 1) / 3)
    const h = (19 * a + b - d - g + 15) % 30
    const i = Math.floor(c / 4)
    const k = c % 4
    const l = (32 + 2 * e + 2 * i - h - k) % 7
    const m = Math.floor((a + 11 * h + 22 * l) / 451)
    const month = Math.floor((h + l - 7 * m + 114) / 31)
    const day = ((h + l - 7 * m + 114) % 31) + 1
    return moment({ year, month: month - 1, day })
}
function getPriorityEvents(year) {
    const easterSunday = getEasterDate(year)
    const palmSunday = easterSunday.clone().subtract(7, 'days')

    return [
        { start: '02-01', end: '02-14', theme: 'vday' },
        { startMoment: palmSunday, endMoment: easterSunday, theme: 'easter', useBaseGenre: true },
        { start: '12-01', end: '12-26', theme: 'christmas' },
        { start: '01-01', end: '01-31', theme: 'back2school', useBaseGenre: true },
        { start: '07-01', end: '07-31', theme: 'back2school', useBaseGenre: true },
    ]
}
export function calculateCurrentSeason() {
    const today = moment()
    const year = today.year()
    const currentDate = today.format('MM-DD')

    const events = getPriorityEvents(year)
    for (const event of events) {
        if (event.startMoment && event.endMoment) {
            if (today.isBetween(event.startMoment, event.endMoment, 'day', '[]')) {
                return event.theme
            }
        } else {
            if (currentDate >= event.start && currentDate <= event.end) {
                return event.theme
            }
        }
    }

    for (const season of BASE_SEASONS) {
        if (currentDate >= season.start && currentDate <= season.end) {
            return season.theme
        }
    }

    return 'summer'
}

export function getSeasonalGenreId(categoryId) {
    const today = moment()
    const year = today.year()
    const currentDate = today.format('MM-DD')

    if (SEASONAL_GENRE_CATEGORIES.has(categoryId)) {
        const events = getPriorityEvents(year)
        for (const event of events) {
            const inEvent = event.startMoment
                ? today.isBetween(event.startMoment, event.endMoment, 'day', '[]')
                : currentDate >= event.start && currentDate <= event.end

            if (inEvent && !event.useBaseGenre) {
                return THEME_TO_GENRE_MAP[event.theme] || 1
            }
            if (inEvent) break
        }
    }

    for (const season of BASE_SEASONS) {
        if (currentDate >= season.start && currentDate <= season.end) {
            return THEME_TO_GENRE_MAP[season.genre] || 1
        }
    }

    return 1
}

export function getAvailableSeasons() {
    return ['summer', 'autumn', 'winter', 'back2school', 'vday', 'easter', 'christmas']
}

export function getSeasonConfig(theme) {
    return BASE_SEASONS.find(s => s.theme === theme) || null
}
